import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';

// Slice Reducers
import homeReducer from './slices/homeSlice';
import clientReducer from './slices/clientSlice';
import chatsReducer from './slices/chatSlice';
import showChatReducer from './slices/showChatSlice';
import modalReducer from './slices/modalSlice';
import vibesReducer from './slices/vibeSlice';
import userReducer from './slices/userSlice';
import registerReducer from './slices/registerSlice';
import deviceReducer from './slices/deviceSlice';
import feedbackReducer from './slices/feedbackSlice';
import boundsReducer from './slices/boundSlice';
import createRoomReducer from './slices/createRoomSlice';
import themeReducer from './slices/themeSlice';

// Service Reducers
import { userAPI } from './services/userApi';
import { chatAPI } from './services/chatApi';
import { vibeAPI } from './services/vibeApi';
import { updateAPI } from './services/updateApi';
import { roomAPI } from './services/roomApi';
import { friendAPI } from './services/friendApi';
import { feedbackAPI } from './services/feedbackApi';
import { mapAPI } from './services/mapApi';
import { searchAPI } from './services/searchApi';

export const store = configureStore({
  reducer: {
    // Separate Slices in Store
    home: homeReducer,
    client: clientReducer,
    chats: chatsReducer,
    showChat: showChatReducer,
    modal: modalReducer,
    vibes: vibesReducer,
    user: userReducer,
    register: registerReducer,
    device: deviceReducer,
    feedback: feedbackReducer,
    bounds: boundsReducer,
    createRoom: createRoomReducer,
    theme: themeReducer,

    // Service Reducers
    [userAPI.reducerPath]: userAPI.reducer,
    [chatAPI.reducerPath]: chatAPI.reducer,
    [vibeAPI.reducerPath]: vibeAPI.reducer,
    [updateAPI.reducerPath]: updateAPI.reducer,
    [roomAPI.reducerPath]: roomAPI.reducer,
    [friendAPI.reducerPath]: friendAPI.reducer,
    [feedbackAPI.reducerPath]: feedbackAPI.reducer,
    [mapAPI.reducerPath]: mapAPI.reducer,
    [searchAPI.reducerPath]: searchAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(userAPI.middleware)
      .concat(chatAPI.middleware)
      .concat(vibeAPI.middleware)
      .concat(updateAPI.middleware)
      .concat(roomAPI.middleware)
      .concat(friendAPI.middleware)
      .concat(feedbackAPI.middleware)
      .concat(mapAPI.middleware)
      .concat(searchAPI.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
